import { render, staticRenderFns } from "./Clock2.vue?vue&type=template&id=295b08a4"
import script from "./Clock2.vue?vue&type=script&lang=js"
export * from "./Clock2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports